import { render } from "./filterList.vue?vue&type=template&id=3bffe358"
import script from "./filterList.vue?vue&type=script&lang=js"
export * from "./filterList.vue?vue&type=script&lang=js"

import "./filterList.vue?vue&type=style&index=0&id=3bffe358&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__